export enum CandidateProfileState {
  Active = 'active',
  Paused = 'paused',
  Deleted = 'deleted',
  DeletionScheduled = 'deletion_scheduled',
}
